import { render, staticRenderFns } from "./ResponsibilityDirectoryFormHeader.vue?vue&type=template&id=46240eca&scoped=true"
import script from "./ResponsibilityDirectoryFormHeader.vue?vue&type=script&lang=js"
export * from "./ResponsibilityDirectoryFormHeader.vue?vue&type=script&lang=js"
import style0 from "./ResponsibilityDirectoryFormHeader.vue?vue&type=style&index=0&id=46240eca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46240eca",
  null
  
)

export default component.exports